
// SIMPLE DATABLE MULTILINGUAL LABELS
function datatableLabels(lang) {
  return {
    fr: {
      placeholder: "Recherche...",
      perPage: "{select} lignes par page",
      noRows: "Aucun résultat trouvé",
      info: "Lignes {start} - {end} / {rows}",
    },
    en: {
      placeholder: "Search...",
      perPage: "{select} entries per page",
      noRows: "No entries found",
      info: "Entries {start} - {end} / {rows}",
    },
    es: {
      placeholder: "Buscar...",
      perPage: "{select} entradas por página",
      noRows: "Entradas no encontradas",
      info: "Entradas {start} - {end} / {rows}",
    },
  }[lang]
}

// Transform XML source to JSON object
function xmlToJson(xml) {
  var obj = {}

  if (xml.nodeType == 1) { // element
    // attributes
    if (xml.attributes.length > 0) {
      for (var j = 0; j < xml.attributes.length; j++) {
        var attribute = xml.attributes.item(j)
        obj['@' + attribute.nodeName] = attribute.nodeValue
      }
    }
  } else if (xml.nodeType == 3) { // text
    obj = xml.nodeValue
  }

  // children
  if (xml.hasChildNodes()) {
    for (var i = 0; i < xml.childNodes.length; i++) {
      var item = xml.childNodes.item(i)
      var nodeName = item.nodeName
      if (typeof (obj[nodeName]) == "undefined") {
        obj[nodeName] = xmlToJson(item)
      } else {
        if (typeof (obj[nodeName].push) == "undefined") {
          var old = obj[nodeName]
          obj[nodeName] = [];
          obj[nodeName].push(old)
        }
        obj[nodeName].push(xmlToJson(item))
      }
    }
  }
  return obj
}

// Wait for n milliseconds (promise)
function wait(ms) {
  return new Promise(function (r, j) {
    return setTimeout(r, ms)
  })
}

// Throttle
function throttle(func, wait) {
  var timer = null
  return function () {
    var _this = this
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }
    if (timer === null) {
      timer = setTimeout(function () {
        func.apply(_this, args)
        timer = null
      }, wait)
    }
  }
}
